var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "section", staticStyle: { "min-width": "1200px" } },
      [
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _vm.job.multipleDischargingPickups
              ? _c(
                  "div",
                  [
                    _vm.top.visible
                      ? _c("cargo-ag-grid", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "1",
                            "config-module": "130146",
                            "grid-options": _vm.top.gridOptions,
                            "grid-params": _vm.top.gridParams,
                            "column-defs": _vm.top.columnDefs,
                            "row-data": _vm.trucking
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.top, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.top, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              _vm.topgridApi = params.api
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.job.multipleDischargingPickups
              ? _c(
                  "div",
                  {
                    staticClass: "app-main-inner-row operations",
                    staticStyle: { padding: "5px 0" }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "2",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: { click: _vm.copyNewHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.copyAndAddPoItems")
                                  ) + " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "3",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: { click: _vm.addHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")) + " ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "4",
                                  disabled: !_vm.btnEnable.btDel,
                                  type: "danger"
                                },
                                on: { click: _vm.delHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")) + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.job.multipleDischargingPickups ? _c("el-divider") : _vm._e(),
            _c(
              "el-form",
              {
                staticClass: "inline-form",
                attrs: {
                  inline: true,
                  "label-width": "100px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  [
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "auto" },
                          attrs: { no: "5.1", disabled: _vm.readonly },
                          on: { change: _vm.multiPickupsChangeHandler },
                          model: {
                            value: _vm.job.multipleDischargingPickups,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.job,
                                "multipleDischargingPickups",
                                $$v
                              )
                            },
                            expression: "job.multipleDischargingPickups"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.MultiDoors")) + " ")]
                      )
                    ]
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "el-form",
              {
                staticClass: "inline-form",
                attrs: {
                  inline: true,
                  "label-width": "140px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("label", { staticStyle: { width: "55px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                    ]),
                    _c("el-input-number", {
                      staticStyle: { width: "118px" },
                      attrs: {
                        no: "6",
                        value: _vm.truckingInfo.quantity || 0,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 0,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.quantity = val
                        }
                      }
                    }),
                    _c("label", { staticStyle: { width: "55px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
                    ]),
                    _c("el-input-number", {
                      staticStyle: { width: "118px" },
                      attrs: {
                        no: "7",
                        value: _vm.truckingInfo.weight || 0.0,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.weight = val
                        }
                      }
                    }),
                    _c("label", { staticStyle: { width: "55px" } }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                    ]),
                    _c("el-input-number", {
                      staticStyle: { width: "118px" },
                      attrs: {
                        no: "8",
                        value: _vm.truckingInfo.cubage || 0.0,
                        disabled: _vm.readonly,
                        min: 0,
                        max: 99999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      on: {
                        input: function(val) {
                          _vm.truckingInfo.cubage = val
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "trucking-form" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "140px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                      },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            width: "400px",
                            display: "inline-block"
                          },
                          attrs: {
                            no: "9",
                            disabled: _vm.readonly,
                            "method-params": {
                              truckCmp: true,
                              active: true,
                              companyLob: "integratedJob"
                            },
                            "default-value": _vm.truckingInfo.carryingCmp || ""
                          },
                          on: {
                            change: function(p) {
                              _vm.truckingInfo.carryingCmp = p.value || 0
                              _vm.carryingCmpChangeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.HaulageContactPerson")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "400px" },
                            attrs: {
                              no: "10",
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                              "allow-create": true,
                              clearable: true,
                              filterable: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.carryingContactsChangeHandler(
                                  false,
                                  false
                                )
                              },
                              blur: _vm.selectContactBlur
                            },
                            model: {
                              value: _vm.truckingInfo.driver,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "driver", $$v)
                              },
                              expression: "truckingInfo.driver"
                            }
                          },
                          _vm._l(_vm.carryingContacts, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.EstPackingDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "11",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeReplacementTime(false)
                            }
                          },
                          model: {
                            value: _vm.truckingInfo.loadingDate,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                            },
                            expression: "truckingInfo.loadingDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.ExpectedArrivalDate2")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "11",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeDischargeTime(false)
                            }
                          },
                          model: {
                            value: _vm.ieTruckInfo.arriveDate,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "arriveDate", $$v)
                            },
                            expression: "ieTruckInfo.arriveDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("Warehouse.Driver"),
                          disabled: _vm.isEdit
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "12" },
                          model: {
                            value: _vm.truckingInfo.driverName,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "driverName", $$v)
                            },
                            expression: "truckingInfo.driverName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("Warehouse.DriverPhone"),
                          disabled: _vm.isEdit
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "45", disabled: _vm.readonly },
                          model: {
                            value: _vm.truckingInfo.driverPhone,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "driverPhone", $$v)
                            },
                            expression: "truckingInfo.driverPhone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("CargoMsg.Cargo_VehicleModel") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "vehicleType",
                            "select-type":
                              _vm.selectTypeNames.basic_data_VehicleModel,
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "custom-label": _vm.vehicleTypeLabel,
                            "method-params": { typeKh: true },
                            clearable: false,
                            "default-value": _vm.ieTruckInfo.vehicleType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ieTruckInfo.vehicleType = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "140px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.HaulageNo") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: { no: "19", disabled: _vm.readonly },
                          on: { change: _vm.refreshGrid },
                          model: {
                            value: _vm.truckingInfo.truckOrderNo,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "truckOrderNo", $$v)
                            },
                            expression: "truckingInfo.truckOrderNo"
                          }
                        }),
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.HaulageCharge")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            no: "40",
                            disabled: _vm.readonly,
                            min: 0,
                            max: 999999999999,
                            precision: 2,
                            "controls-position": "right"
                          },
                          on: { change: _vm.truckingFeeCharge },
                          model: {
                            value: _vm.truckingInfo.truckingFee,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "truckingFee", $$v)
                            },
                            expression: "truckingInfo.truckingFee"
                          }
                        }),
                        _c("span", { staticClass: "currency" }, [
                          _vm._v(_vm._s(_vm.localCurrency))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "41", disabled: _vm.readonly },
                          on: { change: _vm.refreshGrid },
                          model: {
                            value: _vm.truckingInfo.driverTel,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                            },
                            expression: "truckingInfo.driverTel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ActPackingDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "42",
                            disabled: _vm.readonly,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeReplacementTime(true)
                            }
                          },
                          model: {
                            value: _vm.truckingInfo.actLoadingDate,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "actLoadingDate", $$v)
                            },
                            expression: "truckingInfo.actLoadingDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ActualArrivalDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "42",
                            disabled: _vm.readonly,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeDischargeTime(true)
                            }
                          },
                          model: {
                            value: _vm.ieTruckInfo.actualArrivalDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ieTruckInfo,
                                "actualArrivalDate",
                                $$v
                              )
                            },
                            expression: "ieTruckInfo.actualArrivalDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.PlateNumber") }
                      },
                      [
                        _vm.isEdit
                          ? _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: { no: "43", disabled: _vm.readonly },
                              on: {
                                input: function(val) {
                                  _vm.truckingInfo.plateNumber = val.trim()
                                }
                              },
                              model: {
                                value: _vm.truckingInfo.plateNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.truckingInfo, "plateNumber", $$v)
                                },
                                expression: "truckingInfo.plateNumber"
                              }
                            })
                          : _vm._e(),
                        _vm.readonly
                          ? _c("span", { staticClass: "plate_number" }, [
                              _vm._v(_vm._s(_vm.truckingInfo.plateNumber))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_trailerNumber"),
                          disabled: _vm.isEdit
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "45", disabled: _vm.readonly },
                          model: {
                            value: _vm.ieTruckInfo.trailerNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "trailerNumber", $$v)
                            },
                            expression: "ieTruckInfo.trailerNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.travelTime") }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "105px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "13",
                            min: 0,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.truckingInfo.travelHour,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                            },
                            expression: "truckingInfo.travelHour"
                          }
                        }),
                        _c("span", { staticStyle: { margin: "10px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "14",
                            min: 0,
                            max: 59,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.truckingInfo.travelMinute,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "travelMinute", $$v)
                            },
                            expression: "truckingInfo.travelMinute"
                          }
                        }),
                        _c("span", { staticStyle: { margin: "10px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("el-divider"),
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "padding-left": "20px",
                  "padding-bottom": "10px"
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("SeaExport.DestinationGatePoint")))
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "trucking-form" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "140px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Door") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            filterable: "",
                            cache: false,
                            "allow-create": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            disabled: _vm.readonly,
                            "tag-name": "name",
                            "tag-value": "name",
                            "default-value": _vm.ieTruckInfo.doorName,
                            "static-options": _vm.doorList,
                            "filter-tag-names": ["name"]
                          },
                          on: { parentCallBack: _vm.doorsChange2Handler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "16",
                            disabled: _vm.readonly,
                            type: "textarea",
                            rows: 3
                          },
                          model: {
                            value: _vm.ieTruckInfo.doorAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "doorAddress", $$v)
                            },
                            expression: "ieTruckInfo.doorAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("Pricing.BelongingCity")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "160px" },
                                  attrs: {
                                    no: "17",
                                    disabled: _vm.readonly,
                                    "tag-name":
                                      _vm.$store.getters.language === "zh"
                                        ? "chineseName"
                                        : "englishName",
                                    "tag-value": "code",
                                    cache: false,
                                    filterable: "",
                                    "default-value": _vm.ieTruckInfo.cityCode,
                                    "static-options": _vm.cityList,
                                    placeholder: _vm.$t(
                                      "SeaExport.PleaseSelect"
                                    )
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.ieTruckInfo.cityCode =
                                        p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form",
                              {
                                attrs: {
                                  "label-width": "100px",
                                  "label-position": "left"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "custom",
                                    attrs: {
                                      label: _vm.$t("Warehouse.PalletSum")
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "140px" },
                                      attrs: {
                                        no: "18",
                                        value: _vm.ieTruckInfo.palletSum,
                                        disabled: _vm.readonly,
                                        min: 0,
                                        max: 999999999999,
                                        precision: 0,
                                        controls: false
                                      },
                                      on: {
                                        input: function(val) {
                                          _vm.ieTruckInfo.palletSum = val || 0
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "PO" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "po",
                            disabled: _vm.readonly,
                            "filter-chars": false,
                            type: "textarea",
                            rows: 3
                          },
                          model: {
                            value: _vm.ieTruckInfo.po,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "po", $$v)
                            },
                            expression: "ieTruckInfo.po"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "140px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.DoorContactPerson") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "15", disabled: _vm.readonly },
                          model: {
                            value: _vm.ieTruckInfo.doorMan,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "doorMan", $$v)
                            },
                            expression: "ieTruckInfo.doorMan"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { no: "46", disabled: _vm.readonly },
                          model: {
                            value: _vm.ieTruckInfo.doorManTel,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "doorManTel", $$v)
                            },
                            expression: "ieTruckInfo.doorManTel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.DischargingWay") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "400px" },
                            attrs: {
                              value: _vm.ieTruckInfo.dischargingWay
                                ? _vm.ieTruckInfo.dischargingWay.split(",")
                                : [],
                              no: "48",
                              disabled: _vm.readonly,
                              multiple: ""
                            },
                            on: {
                              input: function(value) {
                                _vm.ieTruckInfo.dischargingWay = value.join(",")
                              }
                            }
                          },
                          [
                            _c("el-option", { attrs: { value: "DROP" } }),
                            _c("el-option", {
                              attrs: { value: "LIVE UNLOAD" }
                            }),
                            _c("el-option", {
                              attrs: { value: "EXCHANGE PALLETS" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.LatestDeliveryDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "actDeliveryDate",
                            disabled: _vm.readonly,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          model: {
                            value: _vm.ieTruckInfo.actDeliveryDate,
                            callback: function($$v) {
                              _vm.$set(_vm.ieTruckInfo, "actDeliveryDate", $$v)
                            },
                            expression: "ieTruckInfo.actDeliveryDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }